import { render, staticRenderFns } from "./Accelerators.vue?vue&type=template&id=7ada8bde&scoped=true"
import script from "./Accelerators.vue?vue&type=script&lang=js"
export * from "./Accelerators.vue?vue&type=script&lang=js"
import style0 from "./Accelerators.vue?vue&type=style&index=0&id=7ada8bde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada8bde",
  null
  
)

export default component.exports